module.exports = __webpack_public_path__ + "img/ad_8.d4491f01.png";